// 의견 보내기 액션(rpc) — 조회만 조직에서도 받는다(api 문지기 예외).
import { rpc } from "@/api/client";

export const sendFeedback = (input: { body: string; page: string | null }) => rpc("feedback/actions/sendFeedback", input);
